import type { Component } from "solid-js";
import {
  ASTNodeRenderer,
  type MarkdownRendererOptions,
  SolidStreamingMarkdownContextProvider,
} from "./components/ASTRenderers";
import type { DocASTNode } from "./toastmark/ast";

export { createSolidStreamingMarkdown, type StreamingMarkdownInstance } from "./core";

/**
 * Renders a markdown document.
 *
 * Accepts a reactive markdown document node generated by `createSolidStreamingMarkdown` and
 * renders it into HTML.
 *
 * @example
 * ```ts
 * const parser = createSolidStreamingMarkdown("# Hello world");
 * <SolidStreamingMarkdown doc={parser.doc} />
 * ```
 */
export const SolidStreamingMarkdown: Component<{
  doc: DocASTNode;
  options: MarkdownRendererOptions;
}> = (props) => (
  <SolidStreamingMarkdownContextProvider options={props.options}>
    <ASTNodeRenderer node={props.doc} />
  </SolidStreamingMarkdownContextProvider>
);
